export default async function loadScript(
  urls: string[],
  { onLoad, onError }: { onLoad?: () => void; onError?: (e: Error) => void },
): Promise<void> {
  if (urls.length === 0) {
    if (onLoad) onLoad();
    return;
  }

  const url = urls[0];

  const newScript = document.createElement("script");
  // const srcUrl =
  //   process.env.NODE_ENV !== "development" ? url : url + "?t=" + Date.now();

  newScript.src = url;
  newScript.async = true;
  document.body.appendChild(newScript);

  newScript.onload = () => {
    loadScript(
      urls.filter((e) => e !== url),
      { onLoad, onError },
    );
  };

  newScript.onerror = () => {
    if (onError) onError(Error(`Error loading script: ${url}`));
    loadScript(
      urls.filter((e) => e !== url),
      { onLoad, onError },
    );
  };
}

// for (const script of _scriptUrls) {
//   try {
//     console.log(`Loading script: ${script}`);

//     await import(
//       /* webpackIgnore: true , webpackMode: 'lazy-once' */ script
//     );
//     console.log(`Loaded script: ${script}`);

//     // await import("http://localhost:8080/grapesjs-typed.js");
//     // await import(script);
//   } catch (e) {
//     console.log("Can't import script", script, e);
//   }
// }

// initializeEditor();
